module.exports = "https://portperrypedals.ca/_res/img/herringtons.b0cd3e8.png";